<flo-simple-header [siteId]="siteId$ | async"></flo-simple-header>

<!-- CXP-8207: Varsity Promo Bag -->
<div *ngIf="displayPromoBag$ | async" class="offer-promo-container d-none d-md-flex">
  <div class="offer-promo-product container">
    <div class="d-flex align-items-center">
      <img src="https://d6fm3yzmawlcs.cloudfront.net/funnelAssets/dark-theme/promo-varsity-bag1.png" alt="varsity promo bag" style="width: 200px; height: 200px; background: none;">
    </div>
    <div class="offer-promo-text m-0">
      <h1>Get a free $70 sport bag when you choose an Annual Plan. This is a limited time offer!</h1>
      <p class="caption m-0">While supplies last</p>
    </div>
  </div>
  <div class="offer-promo-details subhead">When choosing an Annual Plan you’ll also save $210.00 per year.</div>
</div>

<div class="container">
  <flo-stepper-wrapper *ngIf="!(isEmbeddedPurchase$ | async)" data-test="stepper" ></flo-stepper-wrapper>
  <h1 data-test="funnel-title" class="funnel-title mt-25">Choose Your Plan</h1>

   <!-- LEGACY PLANS DT / MOBILE -->
  <ng-container *ngIf="!(isInSingleClickDesktopPlansVariation$ | async) && !(isInSingleClickMobilePlansVariation$ | async)">
    <div class="funnel-button-wrapper">
      <button
        data-id="pay-button"
        floAnalytics
        name="Go To Pay"
        class="btn btn-primary selection-btn btn-lg w-100 lg-font-btn"
        (click)="goToNextPage()"
        data-test="go-to-pay-button"
        >Next
      </button>
    </div>

    <div class="main-content" data-test="legacy-content-section">
      <ng-container *ngIf="isInNewPricingArchitectureVariation$ | async; else displayOldPlans">
        <flo-offers
          data-test="offers"
          [selectedOffer]="selectedOffer$ | async"
          [offers]="offers$ | async"
        ></flo-offers>
      </ng-container>
      <ng-template #displayOldPlans>
        <flo-offers
          *ngIf="legacyPlansConfig$ | async as legacyPlansConfig"
          data-test="legacy-plans"
          [legacyPlans]="legacyPlans"
          [offers]="legacyPlansConfig.offers"
          [selectedOffer]="legacyPlansConfig.selectedOffer"
        ></flo-offers>
      </ng-template>
      <!-- only displayed on mobile view -->
      <div
        *ngIf="valueProps$ | async as valueProps"
        class="mobile-value-props d-block d-md-none"
        data-test="mobile-value-props"
      >
        <div class="plan-props-header"><h4>Included with the Selected Plan</h4></div>
        <flo-value-prop
          *ngFor="let valueProp of valueProps; trackBy: trackById"
          label="checkmark-green"
          [proposition]="valueProp"
          svgWidth="18">
        </flo-value-prop>
      </div>
    </div>
  </ng-container>

  <!-- END LEGACY PLANS DT / MOBILE -->

  <!-- CXP-8819: Single-Click Desktop Plans -->
  <div class="main-content gap-0" *ngIf="isInSingleClickDesktopPlansVariation$ | async as isSingleClickDT" data-test="single-click-dt-plans-section">
    <!-- Offer Cards -->
    <div class="offers-wrapper gap-4 d-flex justify-content-center" *ngIf="offers$ | async as offers">
      <div class="offer-container" *ngFor="let offer of offers; trackBy: trackById;">
        <flo-offer-button-card
          [offer]="offer"
          [isMonthly]="offer.offerMetadata.period !== 'year'"
          [buttonText]="'Select'"
          [pricePeriod]="'/month'"
          [showValueProps]="true"
          [showSavings]="true"
          [showSavingsValueProp]="!isSingleClickDT"
          (offerSelected)="onOfferSelected($event)"
          ></flo-offer-button-card>
      </div>
    </div>
  </div>


  <!-- CXP-7255: Single-Click Mobile Plans -->
   <div class="main-content gap-0" *ngIf="isInSingleClickMobilePlansVariation$ | async" data-test="single-click-mobile-plans-section">
      <!-- Offer Cards -->
      <div class="offers-wrapper gap-4 d-flex flex-column" *ngIf="offers$ | async as offers">
        <div *ngFor="let offer of offers; trackBy: trackById;">
          <flo-offer-button-card
            [offer]="offer"
            [isMonthly]="offer.offerMetadata.period !== 'year'"
            [buttonText]="'Select'"
            [pricePeriod]="'/month'"
            [showSavings]="true"
            [showMoreBillingInfo]="true"
            (offerSelected)="onOfferSelected($event)"
            ></flo-offer-button-card>
        </div>
      </div>

      <!-- Value Props -->
       <div class="value-props-wrapper d-flex flex-column" *ngIf="valueProps$ | async as valueProps">
          <h2 class="value-props-title">Included in all plans</h2>
          <div>
              <flo-value-prop
                  *ngFor="let valueProp of valueProps; trackBy: trackById"
                  [proposition]="valueProp"
                  label="single-click-plans"
                  svgWidth="18"
              ></flo-value-prop>
          </div>
       </div>
   </div>

</div>
